import { merchantApi } from '@/config/axios'

export interface ModuleEntitlement {
  moduleId: string
  moduleTitle: string
  subjectType: string
  subjectId: string
  subjectName?: string
  status: string
  sortOrder?: number
}

export interface WorkbenchContext {
  merchantId: number
  merchantName?: string
  /** 商城店铺名称，侧栏优先展示 */
  shopName?: string
  accountId: number
  mainAccount: boolean
  roleCode?: string
  modules: ModuleEntitlement[]
  permissions: string[]
  homePath: string
  /** 商城经营模式 platform / self；空则商家不开票 */
  mallBizMode?: string
}

export const getWorkbenchContext = () =>
  merchantApi.get<WorkbenchContext>({ url: '/merchant-api/b/workbench/context' })
